<div [class.hidden]="!show">
  <div class="loader-overlay">
    <div *ngIf="show" class="loader">
      <mat-progress-bar mode="indeterminate" [color]="'#6da6da'"></mat-progress-bar>
    </div>
  </div>
</div>
